import axios from "axios";

export const refreshApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});
